import { Container } from 'inversify';
import getDecorators from 'inversify-inject-decorators';
import { TYPES } from '@/dependency-injection/types';
import { AuthService } from '@/services/auth-service';
import { CarrierService } from '@/services/carrier-management/carrier-service';
import { CarrierGroupService } from '@/services/carrier-management/carrier-group-service';
import { UserService } from '@/services/user-management/user-service';
import { RoleService } from '@/services/user-management/role-service';
import { WamService } from '@/services/wam-service';
import { ReferenceDataService } from '@/services/reference-data-service';
import { ProfileService } from '@/services/profile-service';
import { VacationService } from '@/services/vacation-service';
import { UtilsService } from '@/services/utils-service';
import { OpportunityService } from '@/services/opportunity-management/opportunity-service';
import { OpportunityActionsService } from '@/services/opportunity-management/opportunity-actions-service';
import { UpMarketLoadConfigService } from '@/services/opportunity-management/opportunity-upmarketloadconfig-service';
import { MaterialService } from '@/services/material-management/material-service';
import { MaterialGroupService } from '@/services/material-management/material-group-service';
import { MaterialTypeService } from '@/services/material-management/material-type-service';
import { MaterialSynonymSrcService } from '@/services/material-management/synonym-src-service';
import { MaterialSynonymBolService } from '@/services/material-management/synonym-bol-service';
import { MaterialSynonymSapService } from '@/services/material-management/synonym-sap-service';
import { PartialSaveService } from './../services/partial-save-service';
import { SupplierService } from '@/services/supplier-service';
import { VendorService } from '@/services/vendor-service';
import { TcnService } from '@/services/vendor-management/tcn-service';
import { DummyTcnService } from '@/services/vendor-management/dummy-tcn-service';
import { SiteService } from '@/services/site-management/site-service';
import { UserPreferenceService } from '@/services/user-preference-service';
import { ContractManagementService } from '@/services/contract-management/contract-management-service';
import { ContractTrackingService } from '@/services/contract-tracking/contract-tracking-service';
var container = new Container();
// register services
container.bind(TYPES.AuthService).to(AuthService);
container.bind(TYPES.CarrierService).to(CarrierService);
container.bind(TYPES.CarrierGroupService).to(CarrierGroupService);
container.bind(TYPES.UserService).to(UserService);
container.bind(TYPES.RoleService).to(RoleService);
container.bind(TYPES.WamService).to(WamService);
container.bind(TYPES.ReferenceDataService).to(ReferenceDataService);
container.bind(TYPES.ProfileService).to(ProfileService);
container.bind(TYPES.VacationService).to(VacationService);
container.bind(TYPES.UtilsService).to(UtilsService);
container.bind(TYPES.SupplierService).to(SupplierService);
container.bind(TYPES.VendorService).to(VendorService);
container.bind(TYPES.TcnService).to(TcnService);
container.bind(TYPES.DummyTcnService).to(DummyTcnService);
container.bind(TYPES.MaterialSynonymSrcService).to(MaterialSynonymSrcService);
container.bind(TYPES.MaterialSynonymBolService).to(MaterialSynonymBolService);
container.bind(TYPES.MaterialSynonymSapService).to(MaterialSynonymSapService);
container.bind(TYPES.OpportunityService).to(OpportunityService);
container.bind(TYPES.OpportunityActionsService).to(OpportunityActionsService);
container.bind(TYPES.UpMarketLoadConfigService).to(UpMarketLoadConfigService);
container.bind(TYPES.MaterialService).to(MaterialService);
container.bind(TYPES.MaterialGroupService).to(MaterialGroupService);
container.bind(TYPES.MaterialTypeService).to(MaterialTypeService);
container.bind(TYPES.PartialSaveService).to(PartialSaveService);
container.bind(TYPES.SiteService).to(SiteService);
container.bind(TYPES.UserPreferenceService).to(UserPreferenceService);
container.bind(TYPES.ContractManagementService).to(ContractManagementService);
container.bind(TYPES.ContractTrackingService).to(ContractTrackingService);
// Lazy inject is good for props
var lazyInject = getDecorators(container).lazyInject;
export { container, lazyInject };
